import React from 'react';
import {
  Modal,
  Text,
  BlockStack,
} from '@shopify/polaris';

const DuplicateGenerationStoryModal = ({ 
  isOpen, 
  onClose, 
  onConfirm 
}) => {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title={<div style={{padding: '16px'}}>{'Confirm Duplication'}</div>}
      primaryAction={{
        content: 'Duplicate',
        onAction: onConfirm,
      }}
      secondaryActions={[
        {
          content: 'Cancel',
          onAction: onClose,
        },
      ]}
      footer={<div style={{padding: '16px'}}></div>}
    >
      <BlockStack gap="400">
        <Text>Are you sure you want to duplicate this generation story? A copy will be created.</Text>
      </BlockStack>
    </Modal>
  );
};

export default DuplicateGenerationStoryModal; 